import { isEmpty } from 'lodash'
import {
  type V1JobPostingCardsComponent,
  type ComponentServiceGetJobPostingCardsRequest,
  type V1GetJobPostingCardsSearchBody
} from 'mnvm-mypage-app-ts-if'
import type React from 'react'
import { memo, useState } from 'react'
import { useJobPostingCards } from '@/feature/Builder/Component/api/getJobPostingCards'
import { Pagenation } from '@/components/base/Pagenation'
import JobPostingCards from '../../components/JobPostingCards/JobPostingCards'
import { Loading } from '@/components/base/Loading/Loading'
import { ScrollToTopButton } from '@/components/ScrollToTopButton'
import { Text4 } from '@/components/base/Text'
import { align } from '@/styles/display'

export const currentPageKey = 'currentPage'

interface Props {
  componentId: string
  component?: V1JobPostingCardsComponent
  getJobPostingCardsSearchBody: V1GetJobPostingCardsSearchBody
}

const JobPostingCardListContainer = ({
  componentId,
  component,
  getJobPostingCardsSearchBody
}: Props): React.ReactElement => {
  if (component === undefined || component?.jobPostingCards === undefined) {
    return <></>
  }

  const [currentPage, setCurrentPage] = useState(
    sessionStorage.getItem(currentPageKey) != null
      ? parseInt(sessionStorage.getItem(currentPageKey) ?? '1', 10)
      : component.pageInfo?.currentPage ?? 1
  )
  const request: ComponentServiceGetJobPostingCardsRequest = {
    body: {
      page: currentPage,
      searchBody: getJobPostingCardsSearchBody
    }
  }

  const q = useJobPostingCards(request, currentPage)

  const pageInfo = q.data?.component?.pageInfo

  // Calculate the range of records being displayed
  const fromIndex =
    ((pageInfo?.currentPage ?? 1) - 1) * (pageInfo?.perPage ?? 0) + 1
  const toIndex = Math.min(
    (pageInfo?.currentPage ?? 1) * (pageInfo?.perPage ?? 0),
    pageInfo?.totalCount ?? 0
  )
  const countRecord =
    fromIndex === toIndex ? fromIndex : `${fromIndex} - ${toIndex}`

  if (Boolean(q.isLoading) || isEmpty(q.data)) {
    return <Loading />
  }

  return (
    <>
      <Text4 textAlign={align.RIGHT}>
        {`表示 ${countRecord} / ${pageInfo?.totalCount ?? 0}`}
      </Text4>
      <JobPostingCards
        componentId={q.data.component?.id}
        component={q.data.component as V1JobPostingCardsComponent}
        refetch={(scrollPosition) => {
          if (!isEmpty(q.data)) window.scrollTo(0, scrollPosition)
        }}
      ></JobPostingCards>

      <Pagenation
        currentPage={pageInfo?.currentPage ?? 0}
        totalPages={pageInfo?.totalPage ?? 0}
        onPageChange={function (page: number): void {
          setCurrentPage(page)
          sessionStorage.setItem(currentPageKey, page.toString())
        }}
      ></Pagenation>
      <ScrollToTopButton></ScrollToTopButton>
    </>
  )
}

export default memo(JobPostingCardListContainer)
